import { processUploadedDocumentPublic } from '@/pages/api/scribeAPIV2';
import { type ProcessUploadedDocumentResponse } from '@heidi/templates/contracts';
import { useMutation } from '@tanstack/react-query';

export const useMutateProcessUploadedDocumentPublic = () => {
  return useMutation<ProcessUploadedDocumentResponse, Error, File[]>({
    mutationFn: async (files: File[]) => {
      const response = await processUploadedDocumentPublic(files);
      return response.data;
    },
  });
};
